var divinePlay={
	btn:$('#divineBtn'),//底部Btn
	btnTxt:$('#divineBtnTxt'),//底部Btn下方文字
	divineShakeImg:$('#divineShakeImg'),//手动摇卦img
	divineShakeList:$('#divineShakeList'),//手动随机结果
	divineChooseSelect:$('#divineChooseSelect'),//手动指定
	divineNum:$('#divineNum'),//报数起卦
	thisOp:0,//当前操作的模式 【0-4】
	shakeIndex:0,//当前手动摇卦次数
	shakeAnim:0,//当前手动摇卦动画
	defaultArr:['老阴','少阳','少阴','老阳'],
	shakeDataArr:[],//手动摇签数据
	chooseDataArr:[],//指定签数据

	// 重置数据
	resetData:function(){
		$('#auto').val(this.thisOp);
		$('#gua').val('');
		switch(this.thisOp){
			case 0:
				this.shakeIndex=0;
				this.shakeAnim=0;
				this.btn.html('开始起卦');
				this.btnTxt.html('需要连续起<em>6</em>卦才是完整卦象');
				this.divineShakeImg.children('img').attr('src','/statics/wap/tool/paipan/liuyao/images/gua_0.png');
				this.divineShakeImg.children('img').eq(1).attr('src','/statics/wap/tool/paipan/liuyao/images/gua_1.png');
				this.divineShakeList.children('div').children('div').removeClass();
				this.divineShakeList.children('div').children('span').html('?');
				break;
			case 1:
				this.chooseDataArr=[];
				this.divineChooseSelect.find('.gua').attr('class','gua');
				this.divineChooseSelect.find('.txt').html('?');
			case 2:
				this.divineNum.find('input[type="text"]').val('');
				this.divineNum.find('input[type="checkbox"]').attr('checked','true');
			default:
				this.btn.html('开始排盘');
				this.btnTxt.html('排盘后可查看卦象结果');
				break;
		}	
	},
	clickFun:function(){
		switch(this.thisOp){
			//手动摇卦
			case 0:
				if(this.shakeAnim){
					// 停止摇签动画
					var d=1;//爻卦当的数量
					for(var i=0;i<3;i++){
						var rand=Math.random()>0.5?1:0;
						if(rand==1) d++;
						this.divineShakeImg.children('img').eq(i).attr('src','/statics/wap/tool/paipan/liuyao/images/gua_'+rand+'.png');
					}
					this.shakeAnim=0;
					var thisSharkObj=this.divineShakeList.children('div').eq(this.shakeIndex);
					thisSharkObj.children('div').addClass('icon_gua_'+d);
					thisSharkObj.children('span').html(this.defaultArr[d-1]);
					this.chooseDataArr[this.shakeIndex]=d-1;//填充数据
					this.shakeIndex++;
					if(this.shakeIndex>5){
						this.btn.html('开始排盘');
						this.btnTxt.html('排盘后可查看卦象结果');
					}else{
						this.btn.html('再次起卦');
						this.btnTxt.html('还需要连续起<em>'+(6-this.shakeIndex)+'</em>卦才是完整卦象');
					}
					
				}else{
					if(this.shakeIndex>5){
						//alert('[老阴,少阳,少阴,老阳]\n'+this.chooseDataArr);
                        $('#gua').val(this.chooseDataArr.join());
						$("#liuyaoForm").find('.J_form_tool_submit').click();
						return;
					}
					// 开始摇签动画
					this.shakeAnim=1;
					this.divineShakeImg.children('img').attr('src','/statics/wap/tool/paipan/liuyao/images/gua2.gif');
					this.btn.html('停止');
				}
				break;
			//手工指定
			case 1:
				for(var i=0;i<=5;i++){
					if(this.chooseDataArr[i]==undefined){
						alert('请选择第'+(i+1)+'爻');
						return;
					}
				}
                $('#gua').val(this.chooseDataArr.join());
                $("#liuyaoForm").find('.J_form_tool_submit').click();
				//alert('[老阴,少阳,少阴,老阳]\n'+this.chooseDataArr);
				break;
			//报数起卦
			case 2:
				var inputVal1=parseInt(this.divineNum.find('input[type="text"]').eq(0).val());
				var inputVal2=parseInt(this.divineNum.find('input[type="text"]').eq(1).val());
				if(inputVal1 % 1 !== 0 || inputVal2 % 1 !== 0 ){
					alert('请输入上卦数、下卦数且须为正整数');
				}else{
                    $('#auto').val(2);
                    $("#liuyaoForm").find('.J_form_tool_submit').click();
				}
				break;
			//时间起卦
			case 3:
				//alert('时间起卦开始排盘');
                $('#auto').val(3);
                $("#liuyaoForm").find('.J_form_tool_submit').click();
				break;
			//电脑自动
			case 4:
				//alert('电脑自动开始排盘');
                $('#auto').val(4);
                $("#liuyaoForm").find('.J_form_tool_submit').click();
				break;
			default:
				break;
		}
	},

	// 入口绑定
	init:function(){
		var that=this;
		// 切换标签
		$('#divineTip').children('span').on('click',function(){
			var index=$(this).index();
			if(index==that.thisOp) return;
			that.thisOp=index;
			that.resetData();//重置数据
			$(this).addClass('active').siblings().removeClass('active');
			$('#divineCon').children('div').eq(index).show().siblings().hide();
		});
		// 切换标签
		that.btn.on('click',function(){
			that.clickFun();
		})
		// 手动指定爻
		that.divineChooseSelect.find('.gua').on('click',function(event){
			event.stopPropagation();
			var thisParent=$(this).parent();
			thisParent.addClass('dw_gua_block_active').siblings().removeClass('dw_gua_block_active');
			var thisIndex=that.divineChooseSelect.children('div').index(thisParent);
			thisParent.children('.select').show().children('span').off().click(function(){
				var indexNum=$(this).index();
				that.chooseDataArr[thisIndex]=indexNum-1;
				thisParent.children('.gua').removeClass().addClass('gua icon_gua_'+(indexNum));
				thisParent.children('.txt').html(that.defaultArr[indexNum-1]);
				thisParent.children('.select').hide();
			})
		})
		//处理手动指定隐藏
		$(document).off().click(function(){
			that.divineChooseSelect.find('.select').hide();
		})
	}
}

$(function(){
	divinePlay.init();
})